module.exports = __webpack_public_path__ + "img/tooltip_01-vallone-feinsteinzeug-gres-all.e35d6e80.jpg";